const CITIES_3 = {
  'oklahoma-city': {
    name: 'Oklahoma City', state: 'OK', population: '690K', restaurants: '1,800+',
    tagline: 'Stockyard heritage meets Midtown creativity',
    foodScene: 'OKC\'s food scene has been reborn around Midtown and Automobile Alley. Cattle-country roots mean excellent steaks and burgers, while Vietnamese and Mexican communities add depth. Onion burgers — smashed patties cooked with mounds of onions — are OKC\'s signature.',
    topCuisines: [
      { emoji: '🍔', name: 'Onion Burgers', note: 'OKC\'s signature invention' },
      { emoji: '🥩', name: 'Steakhouses', note: 'Stockyard heritage beef' },
      { emoji: '🌮', name: 'Mexican', note: 'South OKC authenticity' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Classen Blvd corridor' },
      { emoji: '🍖', name: 'BBQ', note: 'Oklahoma-style smoked meats' },
      { emoji: '🍺', name: 'Craft Beer', note: 'COOP Ale Works, Stonecloud' }
    ],
    neighborhoods: ['Midtown', 'Paseo Arts', 'Automobile Alley', 'Plaza District', 'Classen Corridor', 'Bricktown'],
    knownFor: 'Onion burgers, Cattlemen\'s Steakhouse, Vietnamese corridor, Midtown revival',
    nearby: ['dallas', 'kansas-city', 'memphis']
  },
  'tucson': {
    name: 'Tucson', state: 'AZ', population: '545K', restaurants: '1,500+',
    tagline: 'UNESCO City of Gastronomy',
    foodScene: 'Tucson is the only UNESCO City of Gastronomy in the United States. Food heritage spans 4,000 years of agriculture. Sonoran hot dogs (bacon-wrapped, bean-topped) are a Tucson original. The Mexican food is the most authentic in the US — border proximity means family recipes cross daily.',
    topCuisines: [
      { emoji: '🌭', name: 'Sonoran Hot Dogs', note: 'Bacon-wrapped, bean-topped, iconic' },
      { emoji: '🌮', name: 'Sonoran Mexican', note: 'Most authentic in the US' },
      { emoji: '🌵', name: 'Desert Cuisine', note: 'Prickly pear, mesquite, cholla' },
      { emoji: '🫔', name: 'Tamales', note: 'Family recipes across generations' },
      { emoji: '🥘', name: 'Native American', note: 'Tohono O\'odham heritage foods' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Barrio Brewing, Dragoon' }
    ],
    neighborhoods: ['Fourth Avenue', 'Downtown', 'South Tucson', 'University', 'Barrio Viejo', 'Congress Street'],
    knownFor: 'UNESCO City of Gastronomy, Sonoran hot dogs, authentic Mexican, 4,000-year food heritage',
    nearby: ['phoenix', 'albuquerque', 'el-paso']
  },
  'jacksonville': {
    name: 'Jacksonville', state: 'FL', population: '950K', restaurants: '2,200+',
    tagline: 'Beach vibes and Southern seafood',
    foodScene: 'Jacksonville is Florida\'s largest city by area, spanning beach-town seafood shacks to downtown fine dining. The beaches have casual spots where you eat on the sand. Mayport fishing village serves the freshest shrimp straight off the boats.',
    topCuisines: [
      { emoji: '🦐', name: 'Mayport Shrimp', note: 'Fresh off the boat' },
      { emoji: '🍗', name: 'Southern', note: 'Fried chicken & sweet tea' },
      { emoji: '🐟', name: 'Beach Seafood', note: 'Casual shacks on the sand' },
      { emoji: '🍖', name: 'BBQ', note: 'Florida-meets-Georgia smoke' },
      { emoji: '🌮', name: 'Latin American', note: 'Growing community' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Bold City, Intuition' }
    ],
    neighborhoods: ['San Marco', 'Five Points', 'Riverside', 'Jax Beach', 'Neptune Beach', 'Springfield'],
    knownFor: 'Mayport shrimp, beach seafood, San Marco dining, Southern comfort, craft breweries',
    nearby: ['orlando', 'tampa', 'savannah']
  },
  'albuquerque': {
    name: 'Albuquerque', state: 'NM', population: '565K', restaurants: '1,400+',
    tagline: 'Red or green? Christmas.',
    foodScene: 'In Albuquerque, the most important question is "red or green?" (chile). The answer "Christmas" means both. New Mexican cuisine is distinct — built around Hatch green chile and red chile pods. Blue corn enchiladas, sopapillas, and carne adovada are staples with 400+ years of heritage.',
    topCuisines: [
      { emoji: '🌶️', name: 'New Mexican', note: 'Red or green — or Christmas' },
      { emoji: '🫔', name: 'Enchiladas', note: 'Blue corn, stacked, smothered' },
      { emoji: '🥟', name: 'Sopapillas', note: 'Fried dough with honey' },
      { emoji: '🌮', name: 'Mexican', note: 'South Valley authenticity' },
      { emoji: '🍖', name: 'Carne Adovada', note: 'Red chile-braised pork' },
      { emoji: '🏜️', name: 'Native American', note: 'Pueblo bread & stews' }
    ],
    neighborhoods: ['Old Town', 'Nob Hill', 'Downtown', 'North Valley', 'South Valley', 'Corrales'],
    knownFor: 'Hatch green chile, red vs green, blue corn enchiladas, sopapillas, 400-year heritage',
    nearby: ['denver', 'phoenix', 'el-paso']
  },
  'louisville': {
    name: 'Louisville', state: 'KY', population: '630K', restaurants: '1,700+',
    tagline: 'Bourbon, hot browns, and Derby dining',
    foodScene: 'Louisville is bourbon country — distilleries line the Urban Bourbon Trail and the spirit infuses the food scene. The Hot Brown (open-faced turkey sandwich) was invented at the Brown Hotel. NuLu (New Louisville) has become the creative dining district. Derby season brings two weeks of food festivals.',
    topCuisines: [
      { emoji: '🥃', name: 'Bourbon Culture', note: 'Urban Bourbon Trail distilleries' },
      { emoji: '🥪', name: 'Hot Brown', note: 'Louisville\'s signature sandwich' },
      { emoji: '🍗', name: 'Southern', note: 'Fried chicken & benedictine' },
      { emoji: '🍖', name: 'BBQ', note: 'Kentucky-style mutton & pork' },
      { emoji: '🍽️', name: 'NuLu Dining', note: 'Creative chef-driven corridor' },
      { emoji: '🏇', name: 'Derby Food', note: 'Burgoo, mint juleps, Derby pie' }
    ],
    neighborhoods: ['NuLu', 'Bardstown Road', 'Frankfort Avenue', 'Downtown', 'Butchertown', 'Germantown'],
    knownFor: 'Bourbon Trail, Hot Brown sandwich, Derby dining, NuLu, fried chicken heritage',
    nearby: ['nashville', 'indianapolis', 'cincinnati']
  },
  'richmond': {
    name: 'Richmond', state: 'VA', population: '230K', restaurants: '1,500+',
    tagline: 'Historic capital with a craft food revolution',
    foodScene: 'Richmond has quietly become one of the South\'s most exciting small food cities. The Carytown and Scott\'s Addition neighborhoods are packed with innovative restaurants and craft breweries. Virginia\'s agricultural heritage means farm-to-table isn\'t a trend, it\'s tradition.',
    topCuisines: [
      { emoji: '🍗', name: 'Southern', note: 'Virginia ham, fried chicken' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Scott\'s Addition brewery row' },
      { emoji: '🥗', name: 'Farm-to-Table', note: 'Virginia agricultural heritage' },
      { emoji: '🌮', name: 'International', note: 'Growing diversity' },
      { emoji: '🍖', name: 'BBQ', note: 'Virginia-style smoked meats' },
      { emoji: '🍳', name: 'Brunch', note: 'Carytown weekend ritual' }
    ],
    neighborhoods: ['Carytown', 'Scott\'s Addition', 'The Fan', 'Shockoe Bottom', 'Church Hill', 'Jackson Ward'],
    knownFor: 'Scott\'s Addition breweries, Carytown dining, Virginia ham, farm-to-table, Civil War heritage',
    nearby: ['washington-dc', 'charlotte', 'raleigh']
  },
  'charleston': {
    name: 'Charleston', state: 'SC', population: '150K', restaurants: '1,200+',
    tagline: 'Lowcountry cuisine at its finest',
    foodScene: 'Charleston is a culinary juggernaut that punches miles above its small size. The Lowcountry cuisine — shrimp and grits, she-crab soup, Frogmore stew — is rooted in African, Caribbean, and European traditions. King Street is one of America\'s best dining streets. Multiple James Beard winners call Charleston home.',
    topCuisines: [
      { emoji: '🦐', name: 'Lowcountry', note: 'Shrimp & grits, she-crab soup' },
      { emoji: '🍗', name: 'Southern', note: 'Fried chicken, biscuits, okra' },
      { emoji: '🦀', name: 'Seafood', note: 'Atlantic-fresh daily catches' },
      { emoji: '🍚', name: 'Gullah-Geechee', note: 'West African culinary heritage' },
      { emoji: '🍽️', name: 'Fine Dining', note: 'Multiple James Beard winners' },
      { emoji: '🍺', name: 'Craft Beer', note: 'King Street & Upper Peninsula' }
    ],
    neighborhoods: ['King Street', 'Upper Peninsula', 'Downtown', 'Mount Pleasant', 'James Island', 'Sullivan\'s Island'],
    knownFor: 'Lowcountry cuisine, shrimp and grits, King Street dining, James Beard winners, Gullah food',
    nearby: ['savannah', 'charlotte', 'raleigh']
  },
  'savannah': {
    name: 'Savannah', state: 'GA', population: '150K', restaurants: '800+',
    tagline: 'Moss-draped squares and Southern soul',
    foodScene: 'Savannah\'s food is as atmospheric as its Spanish moss and cobblestone squares. Lowcountry and soul food traditions run deep. The city\'s walkability means restaurant-hopping through historic squares is the perfect evening. Fresh-off-the-boat shrimp from Thunderbolt are a local treasure.',
    topCuisines: [
      { emoji: '🦐', name: 'Lowcountry Seafood', note: 'Thunderbolt shrimp, crab stew' },
      { emoji: '🍗', name: 'Soul Food', note: 'Mrs. Wilkes\' boarding house' },
      { emoji: '🍖', name: 'BBQ', note: 'Georgia-style smoke' },
      { emoji: '🍽️', name: 'Southern Fine Dining', note: 'Historic house restaurants' },
      { emoji: '🥧', name: 'Desserts', note: 'Pralines, pecan pie, banana pudding' },
      { emoji: '🍸', name: 'Cocktails', note: 'Open container on the squares' }
    ],
    neighborhoods: ['Historic District', 'Forsyth Park', 'Starland District', 'Tybee Island', 'Thunderbolt', 'Victorian District'],
    knownFor: 'Lowcountry soul food, Mrs. Wilkes, Thunderbolt shrimp, pralines, square dining',
    nearby: ['charleston', 'atlanta', 'jacksonville']
  },
  'birmingham': {
    name: 'Birmingham', state: 'AL', population: '200K', restaurants: '1,100+',
    tagline: 'The South\'s next great food city',
    foodScene: 'Birmingham has emerged as one of the South\'s most exciting food destinations. Frank Stitt pioneered Southern fine dining at Highlands Bar and Grill (James Beard winner). Avondale is the new food district. The city\'s soul food traditions are unmatched and remarkably affordable.',
    topCuisines: [
      { emoji: '🍗', name: 'Southern & Soul', note: 'Fried chicken, greens, cornbread' },
      { emoji: '🍖', name: 'BBQ', note: 'Alabama white sauce is famous' },
      { emoji: '🍽️', name: 'Fine Southern', note: 'Frank Stitt\'s restaurants' },
      { emoji: '🌮', name: 'International', note: 'Growing immigrant food scene' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Avondale Brewing, TrimTab' },
      { emoji: '🧇', name: 'Brunch', note: 'Five Points South weekend ritual' }
    ],
    neighborhoods: ['Avondale', 'Five Points South', 'Lakeview', 'Homewood', 'Forest Park', 'Pepper Place'],
    knownFor: 'Alabama white sauce BBQ, Highlands Bar & Grill, Avondale food district, soul food',
    nearby: ['nashville', 'atlanta', 'memphis']
  },
  'boise': {
    name: 'Boise', state: 'ID', population: '235K', restaurants: '900+',
    tagline: 'Mountain West\'s rising food star',
    foodScene: 'Boise is the Mountain West\'s fastest-growing food city. The Basque Block is one of the only Basque cultural districts in America (Idaho has the largest Basque population outside Spain). Downtown is packed with farm-to-table restaurants using Idaho\'s legendary potatoes, trout, and ranched meats.',
    topCuisines: [
      { emoji: '🥘', name: 'Basque', note: 'Only Basque Block in America' },
      { emoji: '🥔', name: 'Idaho Comfort', note: 'Finger steaks & potatoes' },
      { emoji: '🥩', name: 'Ranch Beef', note: 'Idaho-raised steaks' },
      { emoji: '🐟', name: 'Trout', note: 'Idaho river-fresh' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Boise Brewing, Payette' },
      { emoji: '🥗', name: 'Farm-to-Table', note: 'Mountain West bounty' }
    ],
    neighborhoods: ['Downtown', 'Basque Block', 'North End', 'Hyde Park', 'Boise Bench', 'Eagle'],
    knownFor: 'Basque food, finger steaks, Idaho potatoes, ranch beef, Boise River trout',
    nearby: ['salt-lake-city', 'portland', 'seattle']
  },
  'omaha': {
    name: 'Omaha', state: 'NE', population: '490K', restaurants: '1,400+',
    tagline: 'Steak capital with Midwest soul',
    foodScene: 'Omaha is steak country — the city built its identity on the Omaha Stockyards, and prime beef is still the calling card. But the food scene has diversified: South Omaha has incredible Mexican food, Dundee and Benson have creative independent restaurants, and the Reuben sandwich was invented here.',
    topCuisines: [
      { emoji: '🥩', name: 'Steaks', note: 'Omaha Steaks hometown' },
      { emoji: '🥪', name: 'Reuben Sandwich', note: 'Invented here at Blackstone Hotel' },
      { emoji: '🌮', name: 'Mexican', note: 'South Omaha authenticity' },
      { emoji: '🍖', name: 'BBQ', note: 'Nebraska-style smoked meats' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Brickway, Kros Strain' },
      { emoji: '🍳', name: 'Brunch', note: 'Dundee & Benson scenes' }
    ],
    neighborhoods: ['Old Market', 'Dundee', 'Benson', 'South Omaha', 'Blackstone', 'Aksarben'],
    knownFor: 'Omaha Steaks, Reuben sandwich, South Omaha Mexican, stockyard heritage',
    nearby: ['kansas-city', 'minneapolis', 'denver']
  },
  'el-paso': {
    name: 'El Paso', state: 'TX', population: '680K', restaurants: '1,600+',
    tagline: 'The most authentic Mexican food in Texas',
    foodScene: 'El Paso sits directly on the Mexican border across from Juárez, making its food the most authentically Mexican in Texas. The city has its own style — green chile enchiladas, burritos stuffed with carne asada, and Mexican street corn on every corner. The food is incredible and incredibly cheap.',
    topCuisines: [
      { emoji: '🌮', name: 'Mexican', note: 'Border-town authenticity' },
      { emoji: '🌶️', name: 'Green Chile', note: 'Hatch chile season is sacred' },
      { emoji: '🫔', name: 'Burritos', note: 'Carne asada & bean' },
      { emoji: '🌽', name: 'Street Food', note: 'Elote, raspados, churros' },
      { emoji: '🍖', name: 'BBQ', note: 'Texas meets New Mexico' },
      { emoji: '🥘', name: 'Interior Mexican', note: 'Mole, birria, menudo' }
    ],
    neighborhoods: ['Downtown', 'Cincinnati District', 'Kern Place', 'Montecillo', 'Upper Valley', 'Mission Valley'],
    knownFor: 'Most authentic Mexican food in Texas, Hatch chile, border-town burritos, cheap eats',
    nearby: ['albuquerque', 'tucson', 'san-antonio']
  },
  'fort-worth': {
    name: 'Fort Worth', state: 'TX', population: '960K', restaurants: '2,800+',
    tagline: 'Where the West begins (and the BBQ doesn\'t stop)',
    foodScene: 'Fort Worth is the cowboy side of DFW — the Stockyards National Historic District is a living cattle-town where you can eat at restaurants that have served ranchers for a century. Near Southside and Magnolia Avenue have creative new restaurants, but the city never forgets its Western roots.',
    topCuisines: [
      { emoji: '🥩', name: 'Steakhouses', note: 'Stockyards rancher heritage' },
      { emoji: '🍖', name: 'Texas BBQ', note: 'Heim, Panther City, Goldee\'s' },
      { emoji: '🌮', name: 'Tex-Mex', note: 'Joe T. Garcia\'s & beyond' },
      { emoji: '🤠', name: 'Western Dining', note: 'Stockyards atmosphere' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Near Southside breweries' },
      { emoji: '🍗', name: 'Southern', note: 'Chicken-fried steak & cream gravy' }
    ],
    neighborhoods: ['Stockyards', 'Near Southside', 'Magnolia Avenue', 'Sundance Square', 'West 7th', 'Camp Bowie'],
    knownFor: 'Stockyards dining, Texas BBQ, Joe T. Garcia\'s, Western heritage, Goldee\'s BBQ',
    nearby: ['dallas', 'austin', 'san-antonio']
  },
  'cincinnati': {
    name: 'Cincinnati', state: 'OH', population: '310K', restaurants: '1,600+',
    tagline: 'Chili, Graeter\'s, and river city charm',
    foodScene: 'Cincinnati has food traditions found nowhere else. Cincinnati chili — cinnamon-spiced, served over spaghetti with cheese and onions — is a polarizing institution (locals are obsessed). Goetta (a German-inspired sausage) is uniquely Cincy. OTR (Over-the-Rhine) has become one of America\'s best urban food neighborhoods.',
    topCuisines: [
      { emoji: '🌶️', name: 'Cincinnati Chili', note: 'Skyline vs Gold Star debate' },
      { emoji: '🌭', name: 'Goetta', note: 'Only-in-Cincinnati sausage' },
      { emoji: '🍦', name: 'Graeter\'s Ice Cream', note: 'French pot process since 1870' },
      { emoji: '🍺', name: 'German Heritage', note: 'OTR beer halls & lagers' },
      { emoji: '🍽️', name: 'OTR Dining', note: 'America\'s best urban renewal' },
      { emoji: '🍖', name: 'BBQ & Comfort', note: 'Midwest hearty portions' }
    ],
    neighborhoods: ['Over-the-Rhine', 'Findlay Market', 'Mount Adams', 'Northside', 'Hyde Park', 'Covington (KY)'],
    knownFor: 'Cincinnati chili, goetta, Graeter\'s ice cream, Over-the-Rhine dining, Findlay Market',
    nearby: ['columbus', 'louisville', 'indianapolis']
  },
  'cleveland': {
    name: 'Cleveland', state: 'OH', population: '370K', restaurants: '1,800+',
    tagline: 'Rock, roll, and pierogi',
    foodScene: 'Cleveland\'s food scene is built on its blue-collar, immigrant heritage. Tremont and Ohio City have become nationally-recognized food neighborhoods. The West Side Market is one of America\'s oldest indoor markets. Polish, Hungarian, and Slovenian heritage shows up in comfort food, while the new restaurant scene in Gordon Square adds creativity.',
    topCuisines: [
      { emoji: '🥟', name: 'Pierogi', note: 'Eastern European heritage' },
      { emoji: '🌭', name: 'Polish Boy', note: 'Cleveland\'s signature sandwich' },
      { emoji: '🥩', name: 'Corned Beef', note: 'Slyman\'s legendary sandwiches' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Great Lakes, Platform, Masthead' },
      { emoji: '🍽️', name: 'Tremont Dining', note: 'Chef-driven neighborhood' },
      { emoji: '🥗', name: 'West Side Market', note: 'America\'s oldest market' }
    ],
    neighborhoods: ['Tremont', 'Ohio City', 'Gordon Square', 'Little Italy', 'West Side Market', 'Lakewood'],
    knownFor: 'West Side Market, pierogi, Polish Boy, Tremont dining, corned beef, Cleveland-style pizza',
    nearby: ['columbus', 'pittsburgh', 'detroit']
  }
};

export default CITIES_3;
